import { SettingObjectType } from '@/interfaces/SettingObjectType';
import { EntityResource } from './entity.resource';

/**
 * Resource ustawienia
 *
 * @export
 * @class SettingResource
 * @extends {EntityResource<Setting>}
 */
export class SettingResource extends EntityResource<SettingObjectType> {
  public getFields = {
    id: true,
    code: true,
    description: true,
    value: true,
    valueType: true,
    group: { id: true }
  };
  public listFields = {
    id: true,
    code: true,
    description: true,
    group: { id: true }
  };

  protected listVariables = { filters: 'SettingFilters' };

  constructor() {
    super({ entityName: 'setting' });
  }
}

export const settingResource = new SettingResource();
